import { useTranslation } from 'react-i18next';
import { Modal } from '@/components/base';
import Icon, { IconName } from '@/components/base/Icon';
import { LanguageDropdown } from '@/components/Sidebar/components/LanguageDropdown';

interface LanguageSwitchModalProps {
  open: boolean;
  onClose: () => void;
}

const LanguageSwitchModal = ({ open, onClose }: LanguageSwitchModalProps) => {
  const { t } = useTranslation('common');
  return (
    <Modal open={open} size="sm">
      <div className="flex flex-col items-center justify-center pb-5">
        <div className="mb-5 flex w-full justify-between">
          <div className="ml-1 text-lg font-bold">{t('eddy_sidebar.setting_language_placeholder')}</div>
          <div className="cursor-pointer" onClick={onClose}>
            <Icon icon={IconName.Close} size={'24px'} />
          </div>
        </div>
        <LanguageDropdown />
      </div>
    </Modal>
  );
};

export default LanguageSwitchModal;
